import { getUID } from '@redviking/argonaut-util/src/getUID';
import type { NodeSpec } from './NodeSpec';
import type { NodeCfg } from '@redviking/argonaut-util/types/mes/applet-designs/flow.latest';

export const startUiNodeSpec: NodeSpec<NodeCfg<'start'>> = {
    canCopy: false,
    canDelete: false,
    canResize: false,
    requiredSockets: 'none',
    cfg: () => ({ id: getUID(), kind: 'start', disabled: false }),
    controls: () => ({}),
    inputs: () => ({}),
    kindLabel: 'Start',
    nodeCategory: 'events',
    suppressNode: true,
    outputs: () => ({ next: { socket: 'event', label: 'Next' } }),
    validator: () => true,
};
